import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  BadgeComponent,
  ButtonComponent,
  IconComponent,
  SpinnerComponent,
  ToastService,
} from '@teorema/patron';
import { Ticket } from 'src/app/models';
import { DocumentationFormComponent } from 'src/app/modules/teo-wiki/documentations-list/form/documentation-form.component';
import { DocumentationService } from 'src/app/shared/services';

@Component({
  selector: 'ts-documentations-tab',
  templateUrl: './ts-documentations-tab.component.html',
  styleUrls: ['./ts-documentations-tab.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DocumentationFormComponent,
    ButtonComponent,
    BadgeComponent,
    IconComponent,
    SpinnerComponent,
  ],
})
export class TsDocumentationsTabComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() entity?: Ticket;
  @Input() canWrite: boolean = true;
  @ViewChild('documentationForm') documentationForm?: DocumentationFormComponent;

  documentations: any[] = [];
  loading = false;
  showForm = false;
  selectedDocumentation: any = null;

  constructor(
    private documentationService: DocumentationService,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.entity?.id) {
      this.loadDocumentations();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entity'] && this.entity?.id) {
      this.loadDocumentations();
    }
  }

  ngAfterViewInit(): void {
    // Componente está pronto após a view ser inicializada
  }

  async loadDocumentations(): Promise<void> {
    if (!this.entity?.id) return;

    this.loading = true;
    try {
      const response = await this.documentationService.getDocumentationsByTicket(this.entity.id);
      this.documentations = response.data || response;
    } catch (error) {
      this.toastService.show({
        color: 'error',
        message: 'Erro ao carregar documentações',
      });
    } finally {
      this.loading = false;
    }
  }

  viewDocumentation(documentation: any): void {
    if (!documentation.slug) return;
    const url = this.router.createUrlTree(['/teo-wiki/visualizar', documentation.slug]);
    window.open(this.router.serializeUrl(url), '_blank');
  }

  openNewDocumentation(): void {
    if (!this.documentationForm || !this.entity) return;

    this.documentationForm.onSave.subscribe(() => {
      this.loadDocumentations();
    });
    this.documentationForm.openModal(undefined, this.entity);
  }

  editDocumentation(documentation: any): void {
    if (!this.documentationForm) return;

    this.documentationForm.onSave.subscribe(() => {
      this.loadDocumentations();
    });
    this.documentationForm.openModal(documentation.id);
  }

  deleteDocumentation(documentation: any): void {
    if (!confirm('Tem certeza que deseja deletar esta documentação?')) {
      return;
    }

    this.loading = true;
    this.documentationService
      .delete(documentation.id)
      .then(() => {
        this.toastService.show({
          color: 'success',
          message: 'Documentação deletada com sucesso!',
        });
        this.loadDocumentations();
      })
      .catch(() => {
        this.toastService.show({
          color: 'error',
          message: 'Erro ao deletar documentação',
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onFormClosed(): void {
    this.showForm = false;
    this.selectedDocumentation = null;
  }
}
